import React, { FC, PropsWithChildren, useContext } from 'react'
import cn from 'classnames'
import { AccordionFaqContext } from './accordion-faq-context'
import { IconMoon, Typography } from '@/atoms'

import styles from './accordion-faq.module.scss'

export const AccordionFaqHeader: FC<PropsWithChildren> = ({
  children,
}: PropsWithChildren) => {
  const { expanded, toggleExpanded } = useContext(AccordionFaqContext)

  return (
    <div className={cn(styles['header'])} onClick={toggleExpanded}>
      <Typography variant="featured-1" withFontFamily={true}>
        {children}
      </Typography>
      {expanded ? (
        <IconMoon className={cn(styles['show'])} name="icon-cerrar" size="xl" />
      ) : (
        <IconMoon name="icon-mas" size="xl" />
      )}
    </div>
  )
}
